// extracted by mini-css-extract-plugin
export default {"widget":"widget_widget__GJivQ","head":"widget_head__gZ+jw"};